import Vue from 'vue'
Vue.config.productionTip = false

// store,router
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import { sync } from 'vuex-router-sync'
sync(store, router)

// loadScript
import LoadScript from 'vue-plugin-load-script'
Vue.use(LoadScript)

// Bootstrap
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
library.add(fas, fab, far)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// FontAwesome WebFont
import '@fortawesome/fontawesome-free-webfonts/css/fontawesome.css'
import '@fortawesome/fontawesome-free-webfonts/css/fa-brands.css'
import '@fortawesome/fontawesome-free-webfonts/css/fa-regular.css'
import '@fortawesome/fontawesome-free-webfonts/css/fa-solid.css'

// jquery.easing
import jqueryEasing from 'jquery.easing'

// vue-table-2
import { ClientTable } from 'vue-tables-2'
Vue.use(ClientTable)

// vuescroll
import vuescroll from 'vuescroll';
Vue.use(vuescroll, {
  ops: {
    // The global config
  },
  name: 'mcScroll' // customize component name, default -> vueScroll
});

// moment
// import moment from 'moment-timezone'
// moment.tz.setDefault('Europe/London')

// const
import ApiManager from '@/utils/ApiManager'
window.ApiManager = ApiManager

import Validator from '@/utils/Validator'
window.Validator = Validator

import Constants from '@/utils/Constants'
Constants['_store'] = store
Constants['checkAuth'] = callback => Constants._store.dispatch('auth/checkAuth', callback)
window.Constants = Constants

window.env = process.env.NODE_ENV

// scss
import '@/assets/scss/main.scss'

// Vuetify
import Vuetify from 'vuetify'
import ja from 'vuetify/lib/locale/en'

Vue.use(Vuetify)
Vue.component('my-vuetify', {
  methods: {
    changeLocale() {
      this.$vuetify.lang.current = 'ja'
    },
  },
})
const vuetify = new Vuetify({
  lang: {
    locales: {ja},
    current: 'ja',
  },
})

// load API Clients
if (process.env.NODE_ENV === 'local') {
  /* eslint-disable no-new */
  // 開発用
  (async function() {
    await Vue.loadScript('/scripts/axios.min.js')
    await Vue.loadScript('/scripts/polyfill.js?d=' + process.env.VUE_APP_VERSION)

    // api
    await Vue.loadScript('/scripts/libs.dev/apiConfig.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientAuthorization.js')
    // dashboard
    await Vue.loadScript('/scripts/libs.dev/apiClientDashboard.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientAdminNotice.js')
    // service
    await Vue.loadScript('/scripts/libs.dev/apiClientService.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientServiceDeliveryType.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientServiceAttributeType.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientServiceFunction.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientServiceMailMagazine.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientServiceLinkedCms.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientServiceRss.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientServiceDropbox.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientServiceContentsSetting.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientServiceContentsApply.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientServiceLinkCategory.js')
    // file
    await Vue.loadScript('/scripts/libs.dev/apiClientFile.js')
    // bot
    await Vue.loadScript('/scripts/libs.dev/apiClientBot.js')
    // 202304 サービス管理に「外部パートナー連携」メニューを追加 ST
    // partner
    await Vue.loadScript('/scripts/libs.dev/apiClientPartner.js')
    // 202304 サービス管理に「外部パートナー連携」メニューを追加 ED
    // mst
    await Vue.loadScript('/scripts/libs.dev/apiClientDeliveryTypeMst.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientNoticeTypeMst.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientLinkedCmsMst.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientScreenConfigMst.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientScreenIdMst.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientSpAppMst.js')
    // user
    await Vue.loadScript('/scripts/libs.dev/apiClientUser.js')
    // notice
    await Vue.loadScript('/scripts/libs.dev/apiClientNotice.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientNoticeBot.js')
    // log
    await Vue.loadScript('/scripts/libs.dev/apiClientLog.js')
    // admp
    await Vue.loadScript('/scripts/libs.dev/apiClientTenant.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientCommunity.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientDevice.js')
    // video chat
    await Vue.loadScript('/scripts/libs.dev/apiClientVideoChat.js')
    // location
    await Vue.loadScript('/scripts/libs.dev/apiClientLocation.js')
    // others
    await Vue.loadScript('/scripts/libs.dev/apiClientConst.js')
    await Vue.loadScript('/scripts/libs.dev/apiClientUtil.js')

    // init vue
    new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  })()

} else {
  // リリース用
  (async function() {
    await Vue.loadScript('/scripts/axios.min.js')
    await Vue.loadScript('/scripts/polyfill.js?d=' + process.env.VUE_APP_VERSION)

    let source = process.env.NODE_ENV === 'development' ?
      '/scripts/apiClients.dev.js' :
      process.env.NODE_ENV === 'staging' ?
      '/scripts/apiClients.stg.js' :
      '/scripts/apiClients.js'
    await Vue.loadScript(source)

    // init vue
    new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  })()
}




